import * as fromPages from './themes.reducer';
import { ActionReducerMap, createFeatureSelector, MetaReducer } from '@ngrx/store';
import { environment } from '../../../../environments/environment';

export const featureKey = 'themes';

export interface ThemeState {
  Themes: fromPages.ThemesState;
}

export const reducers: ActionReducerMap<ThemeState> = {
  Themes: fromPages.ThemeReducer,
};

export const getThemeState = createFeatureSelector<ThemeState>(featureKey);

export const metaReducers: MetaReducer<ThemeState>[] = !environment.production ? [] : [];
